import { render, staticRenderFns } from "./ToothAddMenu.vue?vue&type=template&id=656ee3c5&scoped=true&"
import script from "./ToothAddMenu.vue?vue&type=script&lang=js&"
export * from "./ToothAddMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ee3c5",
  null
  
)

export default component.exports